<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <emp-lookup
            :class-padding="classPadding"
            v-model="selectedEmp"
            label="Employee"
            title="Employee"
            :code-value="false"
            :off-remarks="true"
          ></emp-lookup>
        </v-col>
        <!-- <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
            <v-text-field label="Name" :value="selectedEmp.desc" :class="classPadding"></v-text-field>
          </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="4" md="3" :class="classPadding">
          <v-select
            label="PME Status"
            v-model="pmeStatus"
            :class="classPadding"
            :items="pmeStatuses"
            item-text="text"
            item-value="value"
          ></v-select>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" xs="12" sm="4" md="3" :class="classPadding">
          <v-text-field label="Search" :class="classPadding" v-model="search">
            <!-- <template slot="append">
                <v-icon @click.prevent="search">mdi-magnify</v-icon>
              </template> -->
          </v-text-field>
        </v-col>
        <!-- <v-col cols="12" xs="12" sm="4" md="3" :class="classPadding">
            <v-select  :class="classPadding" :items="searchByItems" item-text="text" item-value="value" v-model="searchBy"></v-select>
          </v-col> -->
      </v-row>

      <v-data-table
        :items="items"
        :headers="headers"
        v-if="items.length > 0"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn icon text @click="select(item)">
            <v-icon>mdi-arrow-right-bold</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.createdDate="{ item }">
          <span>{{ item.createdDate | dateFormat }}</span>
        </template>

        <template v-slot:item.effectDate="{ item }">
          <span>{{ item.effectDate | dateFormat }}</span>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog
      v-model="dialog"
      persistent
      :width="company.client == 'CCF' ? 900 : 500"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
              <v-radio-group column v-model="exportOption">
                <v-radio label="Personnel Movement" value="PME"></v-radio>
                <v-radio label="Allowances" value="Allowances"></v-radio>
                <v-radio
                  label="Salary Action Plan"
                  value="SalaryActionPlan"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <template v-if="company.client === 'LBRB'">
              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <v-text-field
                  label="Verfied By"
                  v-model="lbrbParam.verifiedBy"
                ></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <v-text-field
                  label="Noted By"
                  v-model="lbrbParam.notedBy"
                ></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <v-text-field
                  label="Approved By Head"
                  v-model="lbrbParam.approvedByHead"
                ></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <v-text-field
                  label="Approved By President"
                  v-model="lbrbParam.approvedByPres"
                ></v-text-field>
              </v-col>
            </template>

            <template v-if="company.client === 'CCF' && exportOption == 'PME'">
              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <emp-lookup
                  :class-padding="classPadding"
                  v-model="ccfParam.imSupFrom"
                  label="Immediate Supervisor From"
                  title="Employee"
                  :code-value="false"
                  :off-remarks="true"
                ></emp-lookup>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <emp-lookup
                  :class-padding="classPadding"
                  v-model="ccfParam.imSupTo"
                  label="Immediate Supervisor To"
                  title="Employee"
                  :code-value="false"
                  :off-remarks="true"
                ></emp-lookup>
              </v-col>
              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <emp-lookup
                  :class-padding="classPadding"
                  v-model="ccfParam.nxtLevelFrom"
                  label="Next Level Superior From"
                  title="Employee"
                  :code-value="false"
                  :off-remarks="true"
                ></emp-lookup>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <emp-lookup
                  :class-padding="classPadding"
                  v-model="ccfParam.nxtLevelTo"
                  label="Next Level Superior To"
                  title="Employee"
                  :code-value="false"
                  :off-remarks="true"
                ></emp-lookup>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <emp-lookup
                  :class-padding="classPadding"
                  v-model="ccfParam.imSupRel"
                  label="Immediate Superior - Releasing"
                  title="Employee"
                  :code-value="false"
                  :off-remarks="true"
                ></emp-lookup>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <emp-lookup
                  :class-padding="classPadding"
                  v-model="ccfParam.imSupRec"
                  label="Immediate Superior - Receiving"
                  title="Employee"
                  :code-value="false"
                  :off-remarks="true"
                ></emp-lookup>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <emp-lookup
                  :class-padding="classPadding"
                  v-model="ccfParam.nxtSupRel"
                  label="Next Level Superior - Releasing"
                  title="Employee"
                  :code-value="false"
                  :off-remarks="true"
                ></emp-lookup>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <emp-lookup
                  :class-padding="classPadding"
                  v-model="ccfParam.nxtSupRec"
                  label="Next Level Superior - Receiving"
                  title="Employee"
                  :code-value="false"
                  :off-remarks="true"
                ></emp-lookup>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <emp-lookup
                  :class-padding="classPadding"
                  v-model="ccfParam.preparedBy"
                  label="Prepared By"
                  title="Employee"
                  :code-value="false"
                  :off-remarks="true"
                ></emp-lookup>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <emp-lookup
                  :class-padding="classPadding"
                  v-model="ccfParam.reviewedBy"
                  label="Reviewed By"
                  title="Employee"
                  :code-value="false"
                  :off-remarks="true"
                ></emp-lookup>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <emp-lookup
                  :class-padding="classPadding"
                  v-model="ccfParam.approvedABy"
                  label="Approved By 1"
                  title="Employee"
                  :code-value="false"
                  :off-remarks="true"
                ></emp-lookup>
              </v-col>

              <v-col cols="12" xs="12" sm="8" md="6" :class="classPadding">
                <emp-lookup
                  :class-padding="classPadding"
                  v-model="ccfParam.approvedBBy"
                  label="Approved By 2"
                  title="Employee"
                  :code-value="false"
                  :off-remarks="true"
                ></emp-lookup>
              </v-col>
            </template>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialog = !dialog">Close</v-btn>
          <v-btn
            color="success"
            text
            @click.prevent="exportReport"
            :loading="isExporting"
            >Export</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { isNullOrUndefined } from "../../../validation/validation";
const EmpLookup = () =>
  import("../../maintenance/employee-masterfile/personal-info/Lookup");
const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    selectedEmp: {},
    pmeStatus: "",
    pmeStatuses: [
      { text: "All", value: "" },
      { text: "Approved", value: "APPROVED" },
      { text: "Declined", value: "DECLINED" },
      { text: "Pending", value: "PENDING" },
      { text: "Waiting", value: "WAITING" },
    ],
    searchByItems: [
      { text: "Employee Name", value: "empName" },
      { text: "Transaction No.", value: "transNo" },
      { text: "Date Created", value: "dateCreated" },
      { text: "Movement Type", value: "movType" },
    ],
    searchBy: "empName",
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false,
      },
      {
        text: "Transaction No.",
        value: "transactionNo",
        sortable: false,
      },
      {
        text: "Date Created",
        value: "createdDate",
        sortable: false,
      },
      {
        text: "Emp Name",
        value: "empName",
        sortable: false,
      },
      {
        text: "Movement Type",
        value: "movementType",
        sortable: false,
      },
      {
        text: "Effectivity Date",
        value: "effectDate",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        sortable: false,
      },
    ],
    search: "",
    selectedItem: {},
    dialog: false,
    exportOption: "PME",
    isExporting: false,
    lbrbParam: {},
    ccfParam: {
      imSupFrom: {},
      imSupTo: {},
      nxtLevelFrom: {},
      nxtLevelTo: {},
      imSupRel: {},
      imSupRec: {},
      nxtSupRel: {},
      nxtSupRec: {},
      preparedBy: {},
      reviewedBy: {},
      approvedABy: {},
      approvedBBy: {},
    },
  }),
  computed: {
    ...mapState("company", {
      company: (state) => state.company,
    }),
  },
  components: {
    EmpLookup,
  },
  methods: {
    ...mapActions("company", ["getCompanyInfo"]),
    getData(empCode, status) {
      var param = {
        empCode,
        status,
      };
      this.$axios
        .post(`${API_ENDPOINT}/pme-trans-data`, param)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    select(item) {
      this.dialog = true;
      Object.assign(this.selectedItem, item);
    },
    exportReport() {
      this.isExporting = true;
      var param = {
        EmpCode: this.selectedEmp.code,
        TransactionNo: this.selectedItem.transactionNo,
        Option: this.exportOption,
        LBRBParam: this.lbrbParam,
        CCFParam: {
          imSupFrom: isNullOrUndefined(this.ccfParam.imSupFrom.code)
            ? ""
            : this.ccfParam.imSupFrom.code,
          imSupTo: isNullOrUndefined(this.ccfParam.imSupTo.code)
            ? ""
            : this.ccfParam.imSupTo.code,
          nxtLevelFrom: isNullOrUndefined(this.ccfParam.nxtLevelFrom.code)
            ? ""
            : this.ccfParam.nxtLevelFrom.code,
          nxtLevelTo: isNullOrUndefined(this.ccfParam.nxtLevelTo.code)
            ? ""
            : this.ccfParam.nxtLevelTo.code,
          imSupRel: isNullOrUndefined(this.ccfParam.imSupRel.code)
            ? ""
            : this.ccfParam.imSupRel.code,
          imSupRec: isNullOrUndefined(this.ccfParam.imSupRec.code)
            ? ""
            : this.ccfParam.imSupRec.code,
          nxtSupRel: isNullOrUndefined(this.ccfParam.nxtSupRel.code)
            ? ""
            : this.ccfParam.nxtSupRel.code,
          nxtSupRec: isNullOrUndefined(this.ccfParam.nxtSupRec.code)
            ? ""
            : this.ccfParam.nxtSupRec.code,
          preparedBy: isNullOrUndefined(this.ccfParam.preparedBy.code)
            ? ""
            : this.ccfParam.preparedBy.code,
          notedBy: isNullOrUndefined(this.ccfParam.reviewedBy.code)
            ? ""
            : this.ccfParam.reviewedBy.code,
          approvedABy: isNullOrUndefined(this.ccfParam.approvedABy.code)
            ? ""
            : this.ccfParam.approvedABy.code,
          approvedBBy: isNullOrUndefined(this.ccfParam.approvedBBy.code)
            ? ""
            : this.ccfParam.approvedBBy.code,
        },
      };

      var apiUrl = "";
      if (this.company.client === "CCF" && this.exportOption == "PME") {
        apiUrl = "/api/reports/ccf-pme-report";
      } else {
        if (this.exportOption == "SalaryActionPlan") {
          apiUrl = `${API_ENDPOINT}/pme-trans-preview/salary`;
        } else {
          apiUrl = `${API_ENDPOINT}/pme-trans-preview`;
        }
      }
      this.$axios
        .post(`${apiUrl}`, param)
        .then(({ data }) => {
          var subPath = process.env.VUE_APP_PATH;
          if (this.company.client === "CCF" && this.exportOption == "PME") {
            var nameOfTheCsv = "EmployeeMovement.docx";
            this.$axios
              .get(`/Files/WordDocuments/CCF/${nameOfTheCsv}`, {
                responseType: "blob",
              })
              .then((response) => {
                const downloadUrl = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", nameOfTheCsv);
                document.body.appendChild(link);
                link.click();
                link.remove();
              })
              .catch((err) => console.log(err));
          } else {
            if (this.exportOption == "SalaryActionPlan") {
              // window.open(
              //   `${subPath.slice(0, -1)}${API_ENDPOINT}/export/salary/${data}`
              // )
              //this.isExporting = true;
              var nameOfTheCsv = "SalaryActionPlanExcelIndividual.xlsx";
              this.$axios
                .get(`${apiUrl}/${data}`, {
                  responseType: "blob",
                })
                .then((response) => {
                  const downloadUrl = window.URL.createObjectURL(
                    new Blob([response.data])
                  );
                  const link = document.createElement("a");
                  link.href = downloadUrl;
                  link.setAttribute("download", nameOfTheCsv);
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                })
                .catch((err) => console.log(err));
            } else {
              window.open(
                `${subPath.slice(0, -1)}/report-viewer?reportCode=${
                  data.reportCode
                }&dbName=${data.dbName}&key=${data.key}&companyKey=${
                  data.companyKey
                }&reportUrl=${data.url}&client=${data.client}&paramKey=${
                  data.paramKey
                }&rpt=${data.rpt}&print=preview-pme&logoWidth=${
                  data.logoWidth
                }&logoAlign=${data.logoAlign}`
              );
            }
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isExporting = false;
        });
    },
  },
  created() {
    this.getCompanyInfo();
  },
  watch: {
    selectedEmp({ code }) {
      this.getData(code, this.pmeStatus);
    },
    pmeStatus(val) {
      this.getData(this.selectedEmp.code, val);
    },
  },
};
</script>
